<template>
  <div class="containerG">
    <form action="">
      <img :src="logo" alt="" srcset="" />
      <div class="containerInputs">
        <input type="text" v-model="login.username" placeholder="Login" />
        <input type="password" v-model="login.password" placeholder="Senha" />
        <b-button
          @click="logar"
          variant="info"
          block
          class="mt-4"
          style="height: 40px"
          >Entrar</b-button
        >
      </div>
      <small>&copy; BMS LTDA 2026 </small>
    </form>
  </div>
</template>

<script>
import logo from "../../assets/imgCircle.png";
import { http } from "../../services/config";
export default {
  data() {
    return {
      logo: logo,
      login: {
        username: "",
        password: "",
      },
    };
  },

  methods: {
    async logar() {
      event.preventDefault();
      try {
        const url = "/users/auth/login";
        const { data } = await http.post(url, {
          username: this.login.username,
          password: this.login.password,
        });

        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("username", data.user.username);
        sessionStorage.setItem("setor", data.user.setor);
        this.$router.push({
          path: "/Home",
        });
      } catch (error) {
        if (error.response.status === 401) {
          return this.$toast.open({
            message: "Usuário não Autorizado",
            type: "info",
            // all of other options may go here
          });
        }
        this.$toast.open({
          message: "Ocorreu um erro ao logar",
          type: "error",
          // all of other options may go here
        });
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@200&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Roboto", sans-serif;
  background: #43c6ac;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #191654, #43c6ac) fixed;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #191654, #43c6ac) fixed;
}
.containerG {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #383838;
  background: linear-gradient(
    0deg,
    rgba(56, 56, 56, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
}
form {
    width: 350px;
    height: 60%;
    padding: 20px 30px 5px 30px;
    border: 1px solid #dadada;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgb(255 255 255);
    z-index: 100;
}

.containerInputs {
  display: flex;
  height: 80%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
}
form input[type="text"]:focus,
form input[type="password"]:focus {
  outline: none;
}

form input[type="text"]:hover,
form input[type="password"]:hover {
  color: turquoise;
}

form input[type="submit"]:hover {
  background-color: rgb(45, 167, 154);
}

form input[type="submit"] {
  width: 100%;
  height: 45px;
  border-radius: 5px;
  border: none;
  margin-top: 35px;
  background-color: turquoise;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: 0.5s;
  letter-spacing: 0.1rem;
}

form input[type="text"],
form input[type="password"] {
  width: 100%;
  height: 45px;
  border: 1px solid #43c6ac;
  padding-left: 10px;
  margin: 10px 0;
  font-size: 15px;
  transition: 0.7s;
  color: #666;
  border-left: none;
  border-right: none;
  border-top: none;
  color: turquoise;
  text-decoration: none;
  letter-spacing: 0.1rem;
  background-color: white !important;
}
small {
  position: absolute;
  top: 96%;
  color: white;
}

h1 {
  font-family: "Montserrat Alternates", sans-serif;
  position: absolute;
  top: 67%;
  left: 48%;
  color: rgb(243, 246, 247);
  font-size: 50px;
  letter-spacing: 0.4rem;
}

h2 {
  font-family: "Montserrat Alternates", sans-serif;
  font-size: 25px;
  letter-spacing: 0.2rem;
  text-align: center;
  font-weight: bold;
}

@media (max-width: 700px) {
  h1 {
    display: none;
  }
  form {
    width: 95%;
    height: 900px;
    margin-left: 2.5%;
    padding-left: 15px;
    padding-right: 15px;
  }

  form input[type="text"],
  form input[type="password"] {
    width: 100%;
  }
}

@media (max-width: 1033px) {
  h1 {
    display: none;
  }
}
</style>